<template>
  <section class="location">
      <div class="location-image">
        <iframe :src="iframe" width="280" height="160" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
      </div>
      <div class="location-text">
          <h4 class="text-orange">{{ city }}</h4>
          <p>{{ address }}</p>
          <p>
              <strong>Contato: {{ phone }}</strong>
          </p>
      </div>
      <div class="location-action">
        <a :href="url" class="button button-blue is-small" target="_blank">
            <map-icon width="20" class="icon" />
            <span>ABRIR MAPA</span>
        </a>
      </div>
  </section>
</template>

<script>

import MapIcon from "@/components/Svg/MapIcon";

export default {

    components: { MapIcon },

    props: ['city', 'address', 'phone', 'iframe', 'url']
}
</script>

<style>

</style>
